import { render, staticRenderFns } from "./authFailed.vue?vue&type=template&id=70403a19&scoped=true&"
import script from "./authFailed.vue?vue&type=script&lang=js&"
export * from "./authFailed.vue?vue&type=script&lang=js&"
import style0 from "./authFailed.vue?vue&type=style&index=0&id=70403a19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70403a19",
  null
  
)

export default component.exports